import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from '../../directives/directives.module';
import { EditHilfeDialogComponent } from './edit-hilfe-dialog/edit-hilfe-dialog.component';
import { HilfeButtonComponent } from './hilfe-button/hilfe-button.component';
import { HilfeDialogComponent } from './hilfe-dialog/hilfe-dialog.component';

@NgModule({
    declarations: [HilfeDialogComponent, HilfeButtonComponent, EditHilfeDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressBarModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        DirectivesModule,
        MatTabsModule,
        MatSelectModule,
        MatMenuModule,
    ],
    exports: [HilfeDialogComponent, HilfeButtonComponent],
})
export class HilfeModule {}
